import { render, staticRenderFns } from "./chainStore.vue?vue&type=template&id=5572fdfc&scoped=true"
import script from "./chainStore.vue?vue&type=script&lang=js"
export * from "./chainStore.vue?vue&type=script&lang=js"
import style0 from "./chainStore.vue?vue&type=style&index=0&id=5572fdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572fdfc",
  null
  
)

export default component.exports